/**
 * Detektera om en route ar publik (ingen auth). Anvands av providers som
 * mountas globalt (typ ThemeProvider) for att skippa anrop till
 * `/users/me/...`-endpoints som annars ger 401 i console.
 *
 * Heuristik: testar pathname mot kanda publika prefix + suffix-monster
 * (token-baserade, standalone-vyer, etc). Lista hamtas fran App.js
 * — om en ny publik route lagts till maste den eventuellt laggas till
 * har for att slippa harmless 401 i console.
 */

// Exakta prefix
const PUBLIC_PREFIXES = [
  '/equippass/',
  '/supplier-surveys/',
  '/survey/',
  '/schaktrond-ue/',
  '/ek-extern/',
  '/fraga-svar/respond/',
  '/delat/',
  // Beställarvy: kontrollplanen via länk utan konto (2026-10-17).
  '/kontrollplan-extern/',
  '/assessments/ext/',
  '/assessments/manager/',
  '/leadership-assessment/ext/',
  '/inskrivning/partner/',
  '/inskrivning/admin-access/',
  '/inskrivning/admin-shell/',
  '/foretagsinskrivning/ue/',
  '/projekt-atkomst/',
  // Provanställning: chef/HR svarar via länk i påminnelsemejlet (2026-10-23).
  '/provanstallning/svar',
  '/management-dashboard/external/',
  '/management-system/external/',
  '/management-system/standalone',
  '/management-system/embed/',
  '/ice/external/',
  '/etf-allocation/external/',
  '/signature-generator/external/',
  '/open-books/external/',
  '/open-books/standalone',
  '/time-reporting/external/',
  '/payroll/standalone',
  '/orgplan/standalone',
  '/orgplan/external/',
  '/ek-bibliotek/standalone',
  '/ek-bibliotek/external/',
  '/bak-avstamning/standalone',
  '/bak-avstamning/external/',
  '/mangdavstamning/standalone',
  '/mangdavstamning/external/',
  '/fleet/standalone',
  '/fleet/external/',
  '/fleet/cfo/',
  '/eftermarknad/external/',
  // Externa resurser P1: inhyrdas eget skal med egen inloggning, ingen KanPlan-session (Mikael F38 2026-10-25).
  '/field/extern',
  '/approve/',
  '/klimat/standalone',
  '/klimat/external/',
  '/klimat/demo',
  '/cv-generator/standalone',
  '/cv/external/',
  '/revisions/standalone',
  '/revisions/respond/',
  '/issues/respond/',
  // Chefens attest av utlägg via länk i mejlet (utläggspiloten 2026-10-06).
  '/utlagg/ext/',
  // Ledighet: chefens beslut och medarbetarens svar via länk (nyckeln efter #).
  '/ledighet/ext',
  '/ledighet/svar',
  // Leverantörsportalen för offertförfrågan (Inköp) — token i länken.
  '/offert/',
  '/training/standalone',
  '/training/embed/',
  '/training/external/',
];

// /inskrivning/:code ar publikt MEN /inskrivning/partner|admin-access|admin-shell|...
// hanteras separat ovan. Sa "publikt inskrivning" = pathname startar med
// "/inskrivning/" och nasta segment INTE ar nagot av de redan-publika-prefixen
// eller en kand admin-vy. Eftersom alla auth-rutter under inskrivning ar
// nestade under /projects/:projectId/inskrivning, ar varje toppniva-
// /inskrivning/<code> publikt.
function isPublicInskrivning(pathname) {
  if (!pathname.startsWith('/inskrivning/')) return false;
  const segs = pathname.split('/').filter(Boolean);
  if (segs.length < 2) return false;
  // segs[0]='inskrivning', segs[1]=<code> ELLER 'partner'/'admin-access'/'admin-shell'
  return true;
}

export function isPublicRoute(pathname) {
  if (!pathname || typeof pathname !== 'string') return false;
  if (PUBLIC_PREFIXES.some((p) => pathname.startsWith(p))) return true;
  if (isPublicInskrivning(pathname)) return true;
  return false;
}
